import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown as chevronDown,
  faChevronUp as chevronUp,
} from '@fortawesome/free-solid-svg-icons';

export default function ShowBodyButton({
  showBody,
  toggleShowBody,
  uri,
}: {
  showBody: boolean;
  toggleShowBody: (uri: string) => void;
  uri: string;
}) {
  return (
    <div
      onClick={() => toggleShowBody(uri)}
      style={{ fontFamily: 'Inter' }}
      className={`d-inline-flex align-items-center ms-2 cursor-pointer text-secondary`}
    >
      {showBody && <FontAwesomeIcon className="m-0 p-0" icon={chevronUp} />}
      {!showBody && <FontAwesomeIcon className="m-0 p-0" icon={chevronDown} />}
    </div>
  );
}
